import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import moment from "moment";
import CssClass from "../../../Styles/common.module.css";

const TicketListHistoryTable = (props) => {
  const onTicketDetailsHandler = (e, row) => {
    let functionName = "onTicketDetailsHandler";

    try {
      functionName = onTicketDetailsHandler.name;

      window
        .open(common.c_getWebUrl() + "ViewTicket?_ticketNo=" + row.TICKET_NUM)
    } catch (err) {
      common.c_LogWebError();
    }
  };

  const columns = [
    {
      accessorKey: "CREATE_DATETIME",
      header: "Created Datetime",
      Cell: ({ cell }) =>
        cell.getValue() === "0001-01-01T00:00:00"
          ? "-"
          : moment(cell.getValue()).format("DD/MM/YYYY hh:mm:ss A"),
    },
    {
      accessorKey: "CREATE_NAME",
      header: "Created By",
      size: 60,
    },
    {
      accessorKey: "ORG_NAME",
      header: "Company",
      size: 60,
    },
    {
      accessorKey: "SYSTEM_MST_NAME",
      header: "System",
      size: 60,
    },
    {
      id: "ticketNo",
      header: "Ticket #",
      accessorFn: (row) => (
        <div>
          <span>
            <Comp.Button
              id="btnView"
              type="general"
              size="xl"
              onClick={(e) => onTicketDetailsHandler(e, row)}
            >
              {row.TICKET_NUM}
            </Comp.Button>
          </span>
        </div>
      )
    },
    {
      id: "TICKET_STATUS_TYPE_NAME",
      header: "Status",
      accessorFn: (row) => {
        var className;
        switch(row.TICKET_STATUS_TYPE_NAME) {
          case "OPEN": 
            className = CssClass.openStatus;
            break;
          case "ACKNOWLEDGE":
            className = CssClass.ackStatus;
            break;
          case "CLOSED":
            className = CssClass.closeStatus;
            break;
        }
        return <span className={className}>{row.TICKET_STATUS_TYPE_NAME}</span>;
      }
    },
    {
      accessorKey: "SUBJECT",
      header: "Subject",
    },
    {
      accessorKey: "TICKET_CATEGORY_NAME",
      header: "Category",
    },
    {
      accessorKey: "TICKET_PRIORITY_TYPE_NAME",
      header: "Priority",
      size: 60,
    },
    {
      accessorKey: "ACKNOWLEDGED_NAME",
      header: "Agent",
      size: 60,
    },
    {
      accessorKey: "TOTAL_COMPLETE_TIME",
      header: "Required Mandays",
    },
    {
      accessorKey: "UPDATE_DATETIME",
      header: "Last Update",
    },
    {
      accessorKey: "UPDATE_NAME",
      header: "Update By",
      size: 60,
    },
  ];

  return (
    <>
      <Comp.Table columns={columns} data={props.data} enableStickyHeader />
    </>
  );
};

export default TicketListHistoryTable;
